import initSkins from 'initializers/skinsInitializer';
import initLogoMorph from 'initializers/logoMorphInitializer';
import initGlobalPromiseRejectionHandler from 'initializers/initGlobalRejectionHandler';

initGlobalPromiseRejectionHandler();
initLogoMorph();
initSkins();


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/application/bootstrap_common.js